'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonRequiredCEP = exports.defaultCEP = undefined;
var _wavfichacertaFichacertaUtils = require('@bit/wavfichacerta.fichacerta.utils.normalizers');
var _wavfichacertaFichacertaUtils2 = require('@bit/wavfichacerta.fichacerta.utils.warnings');
var _wavfichacertaFichacertaUtils3 = require('@bit/wavfichacerta.fichacerta.utils.validators');
var sizes = {
  generalMedium: 'col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6'
};
var defaultCEP = exports.defaultCEP = function defaultCEP() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sizes.generalMedium;
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'CEP';
  var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cep';
  return {
    name: name,
    label: label,
    isRequired: true,
    size: size,
    type: 'cep',
    normalize: _wavfichacertaFichacertaUtils.removeNonDigit,
    validate: _wavfichacertaFichacertaUtils3.cepValiadtion,
    props: {
      regex: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
      path: path
    }
  };
};
var nonRequiredCEP = exports.nonRequiredCEP = function nonRequiredCEP() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sizes.generalMedium;
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'CEP';
  var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cep';
  return {
    name: name,
    label: label,
    size: size,
    type: 'cep',
    normalize: _wavfichacertaFichacertaUtils.removeNonDigit,
    warn: _wavfichacertaFichacertaUtils2.cepWarning,
    props: {
      regex: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
      path: path
    }
  };
};